import React from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import {Divider, IconButton, Typography} from '@material-ui/core';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: '15px',
  },
  root1: {
    margin: 0,
    padding: '20px',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: 4,
    color: theme.palette.grey[500],
  },
});
const DialogWithTitle = withStyles(styles)((props) => {
  const {children, classes, onClose, ...other} = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h4">{children}</Typography>
      <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </MuiDialogTitle>
  );
});
const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(3),
    justifyContent: 'center',
  },
}))(MuiDialogActions);
const useStyles = makeStyles((theme) => ({
  expiryDialogContent: {
    fontSize: '1rem',
  },
}));
const ExpiryDialog = ({open, staySignedIn, logOut, title, disableBackdropClick, onClose}) => {
  const classes = useStyles();
  const handleClose = (event, reason) => {
    if (disableBackdropClick && reason === 'backdropClick') {
      return false;
    }
    if (typeof onClose === 'function') {
      onClose();
    }
  };
  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      onClose={handleClose}
      open={open}
      fullWidth
      maxWidth={'sm'}
    >
      <DialogWithTitle id="customized-dialog-title" onClose={staySignedIn}>
        <ReportProblemOutlinedIcon/> Alert
      </DialogWithTitle>
      <Divider/>
      <DialogContent className={`text-center font-weight-bold ${classes.expiryDialogContent}`}>

        You&apos;ve been Idle for a While! Your Session will expire soon.
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          color="primary"
          onClick={staySignedIn}
          className={`themeing-buttons mx-1 mb-3 ${classes.buttonRoot}`}
        >
          Stay Signed In
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExpiryDialog;
